// extracted by mini-css-extract-plugin
module.exports = {"bottomFixed":"styles_bottomFixed__66m4s"};